const DATE_CHANGE_WARNING_DO_NOT_SHOW_KEY = 'raptorjob.dateChangeWarningDoNotShowAgain';
const TIME_CHANGE_WARNING_DO_NOT_SHOW_KEY = 'raptorjob.timeChangeWarningDoNotShowAgain';

export function getDateChangeWarningDoNotShowAgain(): boolean {
  try {
    return localStorage.getItem(DATE_CHANGE_WARNING_DO_NOT_SHOW_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setDateChangeWarningDoNotShowAgain(value: boolean): void {
  try {
    if (value) localStorage.setItem(DATE_CHANGE_WARNING_DO_NOT_SHOW_KEY, 'true');
    else localStorage.removeItem(DATE_CHANGE_WARNING_DO_NOT_SHOW_KEY);
  } catch {
    // ignore
  }
}

export function getTimeChangeWarningDoNotShowAgain(): boolean {
  try {
    return localStorage.getItem(TIME_CHANGE_WARNING_DO_NOT_SHOW_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setTimeChangeWarningDoNotShowAgain(value: boolean): void {
  try {
    if (value) localStorage.setItem(TIME_CHANGE_WARNING_DO_NOT_SHOW_KEY, 'true');
    else localStorage.removeItem(TIME_CHANGE_WARNING_DO_NOT_SHOW_KEY);
  } catch {
    // ignore
  }
}
